// web/src/lib/MsalProvider.tsx — minimal MSAL React context provider.
// @azure/msal-react@2 peer-caps at React 18, so on React 19 we provide the same thin context wrapper locally
// (it only exposes the PublicClientApplication instance — exactly what MsalProvider does). Auth flow itself lives
// in lib/auth.ts (login/logout/token, D14 §1); components read the instance from here if/when they need it.
import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { IPublicClientApplication } from '@azure/msal-browser';

const MsalContext = createContext<IPublicClientApplication | null>(null);

export function MsalProvider({ instance, children }: { instance: IPublicClientApplication; children: ReactNode }) {
  return <MsalContext.Provider value={instance}>{children}</MsalContext.Provider>;
}

export function useMsal(): IPublicClientApplication {
  const ctx = useContext(MsalContext);
  if (!ctx) throw new Error('useMsal must be used within <MsalProvider>');
  return ctx;
}
